import { SiteActionAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { SiteAction } from 'common/types'

export function siteActionToSiteActionAPIResponse(
  siteAction: SiteAction
): SiteActionAPIResponse {
  switch (siteAction) {
    case SiteAction.Ignore:
      return SiteActionAPIResponse.Ignore
    case SiteAction.New:
      return SiteActionAPIResponse.New
    case SiteAction.Review:
      return SiteActionAPIResponse.Review
    case SiteAction.Sold:
      return SiteActionAPIResponse.Sold
    case SiteAction.Update:
      return SiteActionAPIResponse.Update
  }
}
